<template>
    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
        <div class="form-container pt-5">
            <div class="vx-row">
                <immiswitchyesno :required="checkFieldIsRequired({'key':'currentlyInUS','section':tplsection, 'fieldsArray':fieldsArray, 'required':true })" :display="false" :tplkey="'currentlyInUS'" :tplsection="tplsection"   wrapclass=" " :fieldsArray="fieldsArray" :cid="'spo_currentlyInUS'"  :formscope="formscope" v-model="value.currentlyInUS" fieldName="chi_currentlyInUS" label="Are you currently in USA?" placeHolder="Are you currently in USA" />
                <genderField :required="true" :display="false" :formScope="formscope" :fieldsArray="fieldsArray" :gender="value.gender" v-model="value.gender" :tplsection="tplsection" :tplkey="'gender'" :fieldName="'gender'" />
                <div class="divider full-divider mb-10"></div>
                <div class="vx-col w-full">
                    <vx-input-group class="form-input-group FML">
                        <immiInput :display="false" :tplkey="'firstName'" :tplsection="tplsection"   :fieldsArray="fieldsArray" cid="benf" :formscope="formscope" v-model="value.firstName" :required="true" fieldName="spouse_first_name" label="First Name" placeHolder="First Name" />
                        <immiInput :display="false" :tplkey="'middleName'" :tplsection="tplsection"  :fieldsArray="fieldsArray" cid="benm" :formscope="formscope" v-model="value.middleName" :required="true" fieldName="spouse_middle_name" label="Middle Name" placeHolder="Middle Name" />
                        <immiInput :display="false" :allowUpperCase="petition.tenantDetails && checkProperty(petition,'tenantDetails','slug') &&  checkProperty(petition,'tenantDetails','slug') == 'slg'" :tplkey="'lastName'" :tplsection="tplsection"  :fieldsArray="fieldsArray" cid="benl" :formscope="formscope" v-model="value.lastName" :required="true" fieldName="spouse_last_name" label="Last Name" placeHolder="Last Name" />
                    </vx-input-group>
                </div>  
                <immiInput  :display="false" :tplkey="'maidenName'" :tplsection="tplsection" :fieldsArray="fieldsArray" cid="maidenName_Maiden Name" :formscope="formscope" v-model="value.maidenName" :required="true" fieldName="spouse_maidenName" label="Maiden Name" placeHolder="Maiden Name" />
                <datepickerField  :display="false" :tplkey="'dateOfBirth'" :tplsection="tplsection" :fieldsArray="fieldsArray" :dateEnableTo="startEligibleDate" :validationRequired="true" v-model="value.dateOfBirth" :formscope="formscope" fieldName="spouse_dob" label="Date of Birth" />
                <selectField  :display="false" :tplkey="'countryOfBirth'" :tplsection="tplsection"   :fieldsArray="fieldsArray" @input="changeBfProvince" :required="true" :optionslist="countries" v-model="value.countryOfBirthDetails" :formscope="formscope" fieldName="spouse_cob" label="Country of Birth" placeHolder="Country of Birth" />
               
                <selectField  :display="false" :tplkey="'provinceOfBirth'" :tplsection="tplsection"   :fieldsArray="fieldsArray" @input="value.provinceOfBirth = value.provinceOfBirthDetails.id" :required="true" v-if="canRenderField('provinceOfBirth', fieldsArray ,false,tplsection) && bfeprovinceStates.length > 0" :optionslist="bfeprovinceStates" v-model="value.provinceOfBirthDetails" :formscope="formscope" fieldName="spouse_provinceOfBirth" label="Province of Birth" placeHolder="Province of Birth" />
                <immiInput  :display="false" :tplkey="'locationOfBirth'" :tplsection="tplsection" :fieldsArray="fieldsArray" cid="benflocationOfBirth" :formscope="formscope" v-model="value.locationOfBirth" :required="true" fieldName="spouse_locationOfBirth" label="Location of Birth" placeHolder="Location of Birth" />
                <selectField :display="false" :tplkey="'relationshipToYou'" :tplsection="tplsection" :listContainsId="false" :fieldsArray="fieldsArray" :required="true" :optionslist="petition.relationships" v-model="value.relationshipToYou" :formscope="formscope" fieldName="relationshipToYou" label="Your Relationship with the dependent" placeHolder="Relationship" />
            </div>
        </div>
    </vs-col>
    </template>
    
    <script>
    import genderField from '@/views/forms/fields/gender.vue'
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import {
        Trash2Icon
    } from "vue-feather-icons";
    import addressField from "@/views/forms/fields/address.vue";
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import immiPhone from "@/views/forms/fields/phonenumber.vue";
    import immiMask from "@/views/forms/fields/maskinput.vue";
    import immiyesorno from "@/views/forms/fields/yesorno.vue";
    import immiuploader from "@/views/forms/fields/fileupload.vue";
    import immipriorstay from "@/views/forms/fields/priorstay.vue";
    import immitextarea from "@/views/forms/fields/simpletextarea.vue";
    import immieducations from "@/views/forms/fields/educations.vue";
    import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
    //import Datepicker from "vuejs-datepicker-inv";
    import Vue from 'vue';
    import casedocumentslist from "@/views/common/casedocuments.vue";
    import immiemployment from "@/views/forms/fields/employment.vue";
    import moment from "moment";
    import petitionsinformation from "@/views/forms/fields/petitionsinformation.vue";
    import previousSpouseForm from "@/views/petition/gc/previousSpouseForm.vue";
    export default {
        inject: ["parentValidator"],
        props: {
            callFromPerm:{
                type: Boolean,
                default: false,
            },
            countriesWithoutUS:{
                type: Array,
                default: [],
            },
            races_list:{
                type: Array,
                default: [],
            },
            eye_colorList:{
                type: Array,
                default: [],
            },
            hair_colorsList:{
                type: Array,
                default: [],
            },
            feetList:{
                type: Array,
                default: [],
            },
            inchesList:{
                type: Array,
                default: [],
            },
            marital_statuses:{
                type: Array,
                default: [],
            },
            visastatuses:{
                type: Array,
                default: [],
            },
            prefillCountryInQuestionnaire:{
                type: Boolean,
                default: true,
            },
            tplsection:{
                type: String,
                default: null,
            },
            petition: Object,
            countries: Array,
            display: {
                type: Boolean,
                default: false,
            },
            fieldsArray: Array,
            vvas: {
                type: String,
                default: ""
            },
            wrapclass: {
                type: String,
                default: "md:w-1/2"
            },
            datatype: {
                type: String,
                default: ""
            },
            cid: {
                type: String,
                default: null,
            },
            formscope: {
                type: String,
                default: null
            },
            value: null,
            label: {
                type: String,
                default: null,
            },
            fieldName: {
                type: String,
                default: null,
            },
            placeHolder: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            }
        },
        created() {
            this.$validator = this.parentValidator;
        },
    
        components: {
            previousSpouseForm,
             //Datepicker,
            genderField,
            immiInput,
            addressField,
            Trash2Icon,
            datepickerField,
            selectField,
            immiPhone,
            immiMask,
            immiyesorno,
            immiuploader,
            immipriorstay,
            immitextarea,
            immieducations,
            immiswitchyesno,
            casedocumentslist,
            immiemployment,
            petitionsinformation
        },
        data() {
            return {
                fileredMartialList:[],
                disablefield:false,
                h4EadPhotoEmailStmt:'Two US style photographs are required for H4 EAD filing, please mail the copies to our office address: Somireddy Law Group PLLC, 20745 Williamsport Place, Suite 390, Ashburn, Virginia 20147.',
                usastates:[],
                presentDay : moment().subtract(1, 'day'),
                consularProcessingValidator:'',
                featureDates:null,
                startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
                currentDate: new Date(),
                bfeprovinceStates: [],
                statesOfMarriage:[],
            };
        },
        mounted() {
            this.$store.dispatch("getstates", 231).then((response) => {
                this.usastates = response;
            })
            //this.loadStatesByCountry('usastates', 231)
            this.value.relationship ="Spouse"
            if(this.value.I94=='' && this.checkProperty(this.value,'isI94DSExpiryDate') ==false){
                this.value.I94ExpiryDate = null;
                this.disablefield = true;
              }
            if (this.value.countryOfBirthDetails && this.value.countryOfBirth != null) {
                this.loadStatesByCountry('bfeprovinceStates', this.value.countryOfBirth)
            }
            if (this.value.countryOfMarriageDetails && this.value.countryOfMarriage != null) {
                this.loadStatesByCountry('statesOfMarriage', this.value.countryOfMarriage)
            }
            this.loadStatesByCountry('usastates', 231)
            this.featureDates = new Date();
            let currentStatus = this.value.currentStatus;
            if (currentStatus != null) {
                this.value.currentStatusDetails = _.find(this.petition.visaStatusList, function (item) {
                    return item.id == currentStatus
                })
            }
        },
        methods: {
            
            clearCurrentStatusField(val){
                if(val){
                    this.value.statusExpiryDate = null;
                }
            },
            checkDSExpireFields(){
                if(this.checkProperty(this.value,'currentStatusDetails') && !this.checkProperty(this.value,'currentStatusDetails','id')
                ){
                    this.value.isDSExpiryDate = false;
                }
            },
            loadStatesByCountry(model, countryId) {
    
                this.$store.dispatch("getstates", countryId).then((response) => {
                    switch (model) {
                        case "bfeprovinceStates":
                            this.bfeprovinceStates = response;
                        break;
                        case "statesOfMarriage":
                            this.statesOfMarriage = response;  
                        break;
                        case "usastates":
                            this.usastates = response;
                        break;
                       
                    }
    
                });
    
            },
            changeBfProvince(value) {
                this.value.countryOfBirth = this.value.countryOfBirthDetails.id;
                this.bfeprovinceStates = [];
                this.value.provinceOfBirth = null;
                this.value.provinceOfBirthDetails = null;
                this.loadStatesByCountry('bfeprovinceStates', value.id)
            },
        },
        computed:{
            
        }
    };
    </script>
    